import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleLinkClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16 max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="text-xl font-heading text-background-50">黑料吃瓜网</span>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200">
              {footerData.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerData.quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick(link.href);
                    }}
                    className="text-sm text-secondary-200 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">服务信息</h4>
            <ul className="space-y-2.5">
              {footerData.serviceLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick(link.href);
                    }}
                    className="text-sm text-secondary-200 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{footerData.partners}</h4>
            <p className="text-sm text-secondary-300">虚位以待，敬请期待</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-300">
            &copy; 2024-2026 黑料吃瓜网 版权所有
          </p>
          <p className="text-xs text-secondary-400">
            最新黑料不打烊 · 吃瓜群众请坐稳
          </p>
        </div>
      </div>
    </footer>
  );
}